import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div<{ colors: IColors }>`
    padding: ${rem(40)} ${rem(20)} ${rem(15)} ${rem(20)};
    background: ${(props) => props.colors?.colorLightest};
`;

export const WrapperLecturer = styled.div``;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Description = styled.div`
    padding-bottom: ${rem(25)};
    display: flex;
    position: relative;
`;

export const Tabs = styled.div`
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    margin-top: ${rem(20)};
    //overflow: scroll;
`;

export const Tab = styled.div<{ colors: IColors }>`
    margin-right: ${rem(30)};
    color: ${(props) => props.colors.colorLink};
    cursor: pointer;
    //white-space: nowrap;

    &.active {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        border-bottom: 2px solid ${(props) => props.colors.colorLink};
        padding-bottom: ${rem(10)};
    }
`;

export const Moderator = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: ${rem(40)} 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
        align-items: center;
    }
`;

export const ModeratorDesc = styled.div`
    display: block;
`;

export const ModeratorImage = styled.img`
    width: ${rem(110)};
    height: ${rem(110)};
    border-radius: 50%;
    margin-right: ${rem(40)};
`;

export const ModeratorName = styled.div`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding: ${rem(10)} ${rem(5)} ${rem(5)} 0;
`;

export const ModeratorLabel = styled.div`
    margin-bottom: ${rem(2)};
    color: ${({ theme }) => theme.colors.grey};
`;

export const Row = styled.div<{ withoutBorder?: boolean }>`
    display: flex;
    flex-direction: column;
    padding: ${rem(25)} 0;
    ${(prop) => (prop.withoutBorder ? '' : `border-bottom: 1px solid ${prop.theme.colors.secondaryGrey}`)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
    }
`;

export const RowTime = styled.div`
    width: 25%;
    margin-bottom: ${rem(30)};

    @media (max-width: ${breakpoints.sm}px) {
        width: 100%;
    }
`;

export const Time = styled.span``;

export const RowContent = styled.div`
    width: 75%;

    @media (max-width: ${breakpoints.sm}px) {
        width: 100%;
    }
`;

export const RowSection = styled.div`
    display: flex;
    flex-direction: column;
`;

export const RowSectionTitle = styled.span<{ colors: IColors }>`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding-bottom: ${rem(10)};
    color: ${(prop) => prop.colors?.colorNonLecture};
`;

export const RowSectionTitleLecture = styled.span<{ colors: IColors }>`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding-bottom: ${rem(10)};
    color: ${(prop) => prop.colors.colorLink};
`;

export const RowSectionLecturer = styled.span`
    margin-top: ${rem(15)};
    line-height: ${rem(22)};
`;

export const RowSectionLecturerName = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding: 0 ${rem(10)} ${rem(10)} 0;
`;

export const RowSectionLecturerPosition = styled.span`
    color: ${({ theme }) => theme.colors.grey};
`;

export const RowSectionAbstract = styled.div`
    padding-bottom: ${rem(10)};
    color: ${({ theme }) => theme.colors.grey};
    display: flex;
    align-items: center;
`;

export const RowSectionAbstractLink = styled.div<{ colors: IColors }>`
    background: ${(props) => props?.colors?.colorLight};
    color: ${(props) => props?.colors?.colorLink};
    padding: 0 ${rem(4)};
    cursor: pointer;
    margin-left: ${rem(10)};
`;

export const Block = styled.div<{ colors: IColors }>`
    background: ${(props) => props.colors.colorLink};
    padding: ${rem(10)} ${rem(15)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    margin: ${rem(10)} 0;
`;

export const BlockNumber = styled.span<{ colors: IColors }>`
    color: ${({ theme }) => theme.colors.white};
`;

export const BlockName = styled.span`
    color: ${({ theme }) => theme.colors.white};
`;

export const LegislativeLabel = styled.span`
    color: ${({ theme }) => theme.colors.grey};
    display: block;
    margin-top: ${rem(25)};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
`;

export const Content = styled.div`
    margin: 0 ${rem(10)};
`;

export const ContentAbstract = styled.div<{ colors: IColors }>`
    padding: 0 ${rem(10)};
    border-left: 2px solid ${(props) => props?.colors?.colorLine};

    p {
        margin: 0;
        line-height: ${rem(18)};
        font-weight: 300;
        padding: ${rem(10)} 0;
    }
`;

export const BlockPanel = styled.div<{ colors: IColors }>`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    margin-bottom: ${rem(30)};
`;

export const BlockPanelLabel = styled.div<{ colors: IColors }>`
    color: ${({ theme }) => theme.colors.white};
    background: ${(props) => props.colors.colorLink};
    padding: ${rem(10)} ${rem(15)};
`;

export const Empty = styled.div``;
